.app-container {
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start; /* changed from center to flex-start */
  color-scheme: dark;
}

.app-container.theme-light {
  color-scheme: light;
}

.background-layer {
  position: absolute;
  top: -5%;
  left: -5%;
  width: 110%;
  height: 110%;
  z-index: -1;
  background-image: var(--bg-image, none);
  background-size: cover;
  background-position: center;
  filter: brightness(0.7) contrast(1.1) var(--bg-blur, blur(0px));
  transition: background-image 0.5s ease-in-out;
  animation: bgTechAnim 30s infinite alternate ease-in-out;
}

@keyframes bgTechAnim {
  0% { transform: scale(1) translate(0, 0); }
  50% { transform: scale(1.05) translate(1%, 1%); }
  100% { transform: scale(1) translate(-1%, -1%); }
}

.background-video-layer {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100vw;
  height: 100vh;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
  z-index: -1;
  pointer-events: none;
  filter: brightness(0.7) contrast(1.1) var(--bg-blur, blur(0px));
  transition: filter 0.3s ease;
}

.background-video-layer.clean-mode {
  filter: brightness(0.9) contrast(1.05) var(--bg-blur, blur(0px)) !important;
}

.main-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 10;
  width: 100%;
  max-width: 95vw;
  padding: 2rem 2rem 100px 2rem;
  flex: 1;
  overflow: hidden;
}

.top-row {
  display: flex;
  flex-direction: row;
  align-items: stretch; /* Align tops and bottoms */
  justify-content: space-between;
  width: 100%;
  max-width: calc(12 * var(--grid-item-width, 72px) + 11 * var(--grid-column-gap, 30px));
  margin: 6.5vh auto 0.8rem auto; /* center horizontally */
  height: 100px; /* Fixed height to force alignment */
}

.clock-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  text-shadow: var(--text-shadow);
  flex: 1;
}

.date-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.flip-clock {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  margin: 0;
}

.flip-card {
  position: relative;
  overflow: visible;
  color: #fff;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  transform-style: preserve-3d;
}

.flip-animate {
  animation: cardFlip 0.4s ease-in-out;
}

@keyframes cardFlip {
  0% { transform: perspective(400px) rotateX(0deg); }
  49.9% { transform: perspective(400px) rotateX(-90deg); }
  50% { transform: perspective(400px) rotateX(90deg); }
  100% { transform: perspective(400px) rotateX(0deg); }
}

.flip-card-inner {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.digit {
  font-size: 3.2rem;
  font-weight: 700;
  line-height: 1;
  position: relative;
  z-index: 2;
  letter-spacing: 1px;
}

.colon {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0.1rem;
  color: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  line-height: 1;
}

.temp {
  font-size: 3.2rem;
  font-weight: 600;
  letter-spacing: 1px;
  margin: 0;
  line-height: 1;
}

.date, .desc {
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
  margin-top: 0.3rem;
  opacity: 1;
}

.lunar-date, .location {
  font-size: 0.85rem;
  font-weight: 500;
  margin: 0;
  margin-top: 0.3rem;
  opacity: 0.9;
}

.search-container {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.search-box-wrapper {
  width: 100%;
  position: relative;
}

.search-box {
  width: 100%;
  padding: 1rem 1.5rem; /* Reverted height */
  padding-left: 4.5rem;
  border-radius: 30px;
  background: var(--glass-bg);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid var(--glass-border);
  color: var(--text-color);
  font-size: 1.1rem; /* Reverted font */
  outline: none;
  transition: all 0.3s ease;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.search-box:focus {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.search-box::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.search-engine-selector {
  position: absolute;
  left: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  padding: 0.4rem 0.6rem;
  border-radius: 20px;
  cursor: pointer;
  z-index: 10;
  transition: background 0.2s;
}


.search-engine-dropdown {
  position: absolute;
  top: calc(100% + 12px);
  left: 0;
  width: 100%;
  background: rgba(20, 20, 20, 0.98);
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  padding: 1rem;
  z-index: 100;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}

.search-engine-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));
  gap: 12px;
}

.search-engine-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 8px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}

.search-engine-item:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.search-engine-delete-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 16px;
  height: 16px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s, background 0.2s;
  color: #fff;
  z-index: 2;
}

.search-engine-item:hover .search-engine-delete-btn {
  opacity: 1;
}

.search-engine-delete-btn:hover {
  background: rgba(239, 68, 68, 0.8);
}

.search-engine-name {
  font-size: 12px;
  color: inherit;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.add-icon-circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px dashed currentColor;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ai-tabs-container {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  gap: 0.5rem;
  padding: 0 1rem;
  align-items: center;
  margin-top: 1rem;
}

.ai-tab {
  position: relative;
  overflow: hidden;
  padding: 0.2rem 1.2rem; /* Reduced height (top/bottom padding) */
  border-radius: 15px; /* Adjust radius for thinner box */
  cursor: pointer;
  color: rgba(255, 255, 255, 0.7);
  transition: all 0.2s ease;
  font-size: 0.95rem;
  text-shadow: var(--text-shadow);
  border: 1px solid transparent;
  display: flex;
  align-items: center;
}

.ai-tab span {
  display: inline-block;
  white-space: nowrap;
  transition: transform 0.2s ease;
}

.ai-tab:has(.ai-delete-btn:hover) span {
  transform: translateX(-8px);
}

.ai-tab:hover {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 1);
}

.ai-tab.active {
  background: rgba(255, 255, 255, 0.25);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.ai-delete-btn {
  position: absolute;
  right: 0.3rem;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  opacity: 0;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.ai-delete-btn:hover {
  opacity: 1;
  color: #ff4444;
}

.ai-add-btn {
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.7);
  transition: color 0.2s ease;
  padding: 0.2rem;
}

.ai-add-btn:hover {
  color: #fff;
}

/* Weather styling */
.weather-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  text-shadow: var(--text-shadow);
}

.weather-header {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.weather-group {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

/* Hover widgets (Clock & Weather) */
.hover-widget {
  position: relative;
  border-radius: 16px;
  padding: 12px 16px;
  margin: -12px -16px;
  transition: all 0.3s ease;
  border: 1px solid transparent;
}

.hover-widget:hover {
  background: var(--glass-bg);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-color: var(--glass-border);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.widget-close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  cursor: pointer;
  opacity: 0;
  transition: all 0.2s ease;
  z-index: 10;
}

.hover-widget:hover .widget-close-btn {
  opacity: 1;
}

.widget-close-btn:hover {
  background: rgba(255, 68, 68, 0.8);
}



.clock-hover-area {
  display: flex;
  flex-direction: column;
}

.weather-hover-area {
  display: flex;
  flex-direction: column;
}

.clock-hover-area .widget-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.weather-hover-area .widget-content {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.placeholder-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.9);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.is-closed {
  cursor: pointer;
}

.is-closed:hover .placeholder-overlay {
  opacity: 1;
}

.placeholder-overlay span {
  font-size: 13px;
  font-weight: 500;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, var(--grid-item-width, 72px));
  grid-auto-rows: var(--grid-item-height, 100px);
  /* Enable dense flow to allow smaller items to fill gaps when widgets wrap to next row */
  grid-auto-flow: row dense;
  width: 100%;
  max-width: calc(12 * var(--grid-item-width, 72px) + 11 * var(--grid-column-gap, 30px));
  margin: 0 auto; /* Center the grid container itself if it hits max-width */
  justify-content: center;
}

.dragging {
  opacity: 0.5;
  transform: scale(1.05);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  z-index: 100;
}

.shortcut-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 0.2s ease;
  text-decoration: none;
  color: var(--text-color);
  width: 100%;
  height: 100%;
}

/* Optional no-glass mode */
.no-glass-icons .shortcut-icon {
  background: transparent !important;
  backdrop-filter: none !important;
  border: none !important;
  box-shadow: none !important;
}
.no-glass-icons .shortcut-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.no-glass-icons .widget-body {
  background: transparent !important;
  backdrop-filter: none !important;
  /* Use theme text color for border to support future light theme */
  border: 1px solid var(--text-color, rgba(255, 255, 255, 0.6)) !important; 
  box-shadow: none !important;
}
.no-glass-icons .shortcut-icon:hover,
.no-glass-icons .widget-body:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1) !important;
}

.shortcut-icon {
  position: relative;
  transition: all 0.2s ease;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px; 
  height: 72px; 
  border-radius: 18px; 
  background: var(--glass-bg);
  backdrop-filter: blur(10px);
  border: 1px solid var(--glass-border);
  box-shadow: 0 4px 16px rgba(0,0,0,0.1); 
  flex-shrink: 0;
  box-sizing: border-box;
}

.shortcut-icon img {
  width: 60%;
  height: 60%;
  object-fit: contain;
  transition: all 0.2s ease;
}

.shortcut-name {
  font-size: 0.85rem;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  text-shadow: 0 2px 4px rgba(0,0,0,0.5);
  transition: all 0.2s ease;
  line-height: 1.3;
  margin: 0;
  margin-top: 0.4em;
  flex-shrink: 0;
}

.widget-item {
  width: 100%;
  height: 100%;
}

.widget-item.size-1x1 { grid-column: span 1; grid-row: span 1; }
.widget-item.size-1x1 .widget-body {
  border-radius: 18px; /* Match standard icon size rounded corners roughly */
}

.widget-item.size-2x2 { grid-column: span 2; grid-row: span 2; }
.widget-item.size-1x2 { grid-column: span 1; grid-row: span 2; }
.widget-item.size-2x1 { grid-column: span 2; grid-row: span 1; }
.widget-item.size-2x4 { grid-column: span 4; grid-row: span 2; }
.widget-item.size-4x2 { grid-column: span 4; grid-row: span 2; }

.widget-body {
  width: 100%;
  height: 100%;
  background: var(--glass-bg);
  backdrop-filter: blur(10px);
  border: 1px solid var(--glass-border);
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  padding: 1.2rem;
  box-shadow: 0 6px 20px rgba(0,0,0,0.15);
  box-sizing: border-box;
  flex-shrink: 0;
}

/* Sidebar Menu Bar */
.sidebar-menu-bar {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--glass-bg);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid var(--glass-border);
  padding: 0.8rem 0;
  z-index: 50;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s, width 0.3s;
  max-height: calc(100vh - 60px);
  box-sizing: border-box;
  overflow: hidden;
}

.sidebar-menu-list {
  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(0.2rem, 1vh, 0.65rem);
  overflow: hidden !important;
  overflow-y: hidden !important;
  touch-action: none;
  -ms-overflow-style: none;
  scrollbar-width: none;
  padding: 0.1rem 0;
}

.sidebar-menu-list::-webkit-scrollbar {
  display: none !important;
}

.sidebar-bottom-actions {
  flex-shrink: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  padding-top: 0.4rem;
}

.sidebar-menu-bar.right {
  right: 0;
  border-right: none;
  border-radius: 20px 0 0 20px;
}

.sidebar-menu-bar.left {
  left: 0;
  border-left: none;
  border-radius: 0 20px 20px 0;
}

.sidebar-menu-bar.right.auto-hide {
  transform: translate(100%, -50%);
}
.sidebar-menu-bar.right.auto-hide::before {
  content: '';
  position: absolute;
  left: -20px;
  top: 0;
  width: 20px;
  height: 100%;
}
.sidebar-menu-bar.right.auto-hide:hover {
  transform: translate(0, -50%);
}

.sidebar-menu-bar.left.auto-hide {
  transform: translate(-100%, -50%);
}
.sidebar-menu-bar.left.auto-hide::before {
  content: '';
  position: absolute;
  right: -20px;
  top: 0;
  width: 20px;
  height: 100%;
}
.sidebar-menu-bar.left.auto-hide:hover {
  transform: translate(0, -50%);
}

.menu-item {
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 54px;
  border-radius: 0;
  padding: 6px 0;
  gap: 4px;
  flex-shrink: 0;
}

.menu-item:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
}

.menu-item.active {
  color: #fff;
  background: rgba(255, 255, 255, 0.25);
}

/* Scrolling Pages */
.pages-viewport {
  width: 100%;
  flex: 1;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}

.pages-wrapper {
  width: 100%;
  height: 100%;
  will-change: transform;
  display: flex;
  flex-direction: column;
}

.page-section {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 36px; /* Added padding to prevent hover overlap with divider */
  position: relative;
}
.page-section::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.placeholder-content {
  color: white;
  text-align: center;
  font-size: 1.5rem;
  opacity: 0.9;
  text-shadow: var(--text-shadow);
  background: var(--glass-bg);
  backdrop-filter: blur(10px);
  padding: 4rem 6rem;
  border-radius: 24px;
  border: 1px solid var(--glass-border);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.placeholder-content h2 {
  font-size: 3rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

/* Bottom Dock Menu */
.dock-menu {
  display: flex;
  align-items: center;
  background: var(--glass-bg);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid var(--glass-border);
  border-radius: 24px;
  padding: 0.8rem 1.5rem;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  height: auto;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 50;
  transition: transform 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55), opacity 0.3s ease;
}

.dock-menu.hidden {
  transform: translate(-50%, 150px);
  opacity: 0;
  pointer-events: none;
}


.dock-section {
  display: flex;
  align-items: center;
  height: 100%;
}

.dock-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  margin-right: 1rem;
  text-align: center;
}

.dock-icons {
  display: flex;
  gap: 1.2rem;
  align-items: center;
  padding: 4px 6px;
  overflow: visible;
}

.dock-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  overflow: hidden;
  position: relative;
}

.dock-icon.add-btn {
  background: rgba(255, 255, 255, 0.8);
}

.dock-icon:hover {
  transform: translateY(-4px) scale(1.1);
  position: relative;
  z-index: 10;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

.dock-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dock-divider {
  width: 1px;
  height: 70%;
  background: rgba(255, 255, 255, 0.2);
  margin: 0 1.2rem;
}

/* Show button */
.dock-show-btn {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  background: var(--glass-bg);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid var(--glass-border);
  border-bottom: none;
  border-radius: 16px 16px 0 0;
  padding: 0.2rem 1.5rem;
  cursor: pointer;
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.1);
}

.dock-show-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.theme-light .dock-show-btn {
  background: rgba(0, 0, 0, 0.2) !important;
  border-color: rgba(0, 0, 0, 0.1) !important;
}

.theme-light .dock-show-btn:hover {
  background: rgba(0, 0, 0, 0.3) !important;
}

/* Bottom Right Actions (Settings & Theme & Clean Mode) */
.bottom-right-actions {
  position: absolute;
  bottom: 16px;
  z-index: 50;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.5rem 1rem;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.bottom-right-actions.pos-right {
  right: -6px;
  border-radius: 20px 0 0 20px;
}

.bottom-right-actions.pos-left {
  left: -6px;
  flex-direction: row-reverse;
  border-radius: 0 20px 20px 0;
}

.bottom-right-actions.pos-right.auto-hide {
  transform: translateX(100%);
}
.bottom-right-actions.pos-right.auto-hide::before {
  content: '';
  position: absolute;
  left: -20px;
  top: 0;
  width: 20px;
  height: 100%;
}
.bottom-right-actions.pos-right.auto-hide:hover {
  transform: translateX(0);
}

.bottom-right-actions.pos-left.auto-hide {
  transform: translateX(-100%);
}
.bottom-right-actions.pos-left.auto-hide::before {
  content: '';
  position: absolute;
  right: -20px;
  top: 0;
  width: 20px;
  height: 100%;
}
.bottom-right-actions.pos-left.auto-hide:hover {
  transform: translateX(0);
}

.action-btn {
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  position: relative;
}

.action-btn[data-title]:hover::after {
  content: attr(data-title);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 8px;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  animation: tooltipFadeIn 0.2s forwards;
  animation-delay: 0.3s;
  z-index: 1000;
}

@keyframes tooltipFadeIn {
  to { opacity: 1; }
}

.action-btn[data-title]::after {
  background: rgba(0, 0, 0, 0.85);
  color: #fff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  border: 1px solid rgba(255,255,255,0.1);
}

.theme-light .action-btn:hover {
  background: rgba(0, 0, 0, 0.15) !important;
  color: #fff;
}

.theme-light .action-btn[data-title]::after {
  background: rgba(255, 255, 255, 0.95);
  color: #333;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.action-btn svg {
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.5));
}

.action-btn:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.2) !important;
  transform: scale(1.1);
}

.action-divider {
  width: 1px;
  height: 20px;
  background: rgba(255, 255, 255, 0.3);
  box-shadow: 0 1px 2px rgba(0,0,0,0.2);
  margin: 0 0.5rem;
}

.login-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal-content {
  background: rgba(30, 30, 40, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 24px;
  padding: 2.5rem;
  width: 400px;
  max-width: 90vw;
  position: relative;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
  color: white;
  animation: slideUp 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(30px) scale(0.95); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.modal-close {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.2s;
}

.modal-close:hover {
  opacity: 1;
}

.modal-title {
  text-align: center;
  margin-bottom: 2rem;
  font-size: 1.5rem;
  font-weight: 600;
}

.login-tabs {
  display: flex;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 2rem;
}

.login-tab {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.8rem 0;
  cursor: pointer;
  opacity: 0.6;
  transition: all 0.2s;
  border-bottom: 2px solid transparent;
}

.login-tab.active {
  opacity: 1;
  border-bottom-color: #3b82f6;
  font-weight: 500;
  color: #3b82f6;
}

.login-tab:hover:not(.active) {
  opacity: 0.8;
}

/* Phone Login */
.phone-login {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}

.login-input {
  width: 100%;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0.8rem 1rem;
  border-radius: 12px;
  color: white;
  outline: none;
  font-size: 1rem;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.login-input:focus {
  border-color: #3b82f6;
}

.verification-group {
  display: flex;
  gap: 0.8rem;
}

.get-code-btn {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
  border: 1px solid rgba(59, 130, 246, 0.5);
  border-radius: 12px;
  padding: 0 1rem;
  cursor: pointer;
  white-space: nowrap;
  font-size: 0.9rem;
  transition: all 0.2s;
}

.get-code-btn:hover {
  background: rgba(59, 130, 246, 0.2);
}

.submit-login-btn {
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 12px;
  padding: 0.8rem;
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  margin-top: 0.5rem;
  transition: background 0.2s;
}

.submit-login-btn:hover {
  background: #2563eb;
}

.login-terms {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 0.5rem;
}

/* WeChat Login */
.wechat-login {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 1rem 0;
}

.qrcode-placeholder {
  width: 180px;
  height: 180px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
}

.wechat-login p {
  margin: 0;
  font-size: 1rem;
}

.qrcode-subtext {
  font-size: 0.85rem !important;
  color: rgba(255, 255, 255, 0.5);
}

/* Clean Mode */
.background-layer.clean-mode {
  background-image: none !important;
  background-color: #121212 !important;
}

.top-row.clean-mode {
  justify-content: center;
  align-items: flex-start;
  height: auto;
}

.center-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  flex: 3;
  max-width: 640px;
  margin: 0 2rem;
}

.weather-container.horizontal {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  text-shadow: none;
  background: transparent;
}

.weather-container.horizontal .weather-icon {
  margin-right: 0;
}

/* Add Group Modal */
.add-group-modal {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 340px;
  height: 480px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background: rgba(26, 26, 30, 0.95);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-radius: 16px;
  padding: 16px 18px 18px;
  color: #fff;
  z-index: 100;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  font-family: inherit;
  animation: modalFadeIn 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  overflow: hidden;
}

.add-group-modal.pos-right {
  right: 90px;
  left: auto;
}

.add-group-modal.pos-left {
  left: 90px;
  right: auto;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(-50%) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(-50%) scale(1);
  }
}

.add-group-close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.45);
  background: rgba(255, 255, 255, 0.04);
  transition: all 0.2s;
  z-index: 2;
}

.add-group-close-btn:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.12);
}

.add-group-header {
  font-size: 1rem;
  font-weight: 600;
  height: 38px;
  margin-bottom: 12px;
  color: #fff;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

/* Tabs Header */
.add-group-tabs {
  display: flex;
  height: 36px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.06);
  padding: 3px;
  border-radius: 10px;
  margin-bottom: 12px;
  position: relative;
  gap: 4px;
  width: calc(100% - 32px);
  flex-shrink: 0;
}

.add-group-tab {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 12px;
  font-size: 0.85rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.6);
  border-radius: 7px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
}

.add-group-tab:hover {
  color: rgba(255, 255, 255, 0.9);
  background: rgba(255, 255, 255, 0.04);
}

.add-group-tab.active {
  background: #3b82f6;
  color: #fff;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.35);
}

/* Preset Groups Tab */
.preset-group-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.preset-group-subtitle {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.45);
  margin-bottom: 10px;
  flex-shrink: 0;
}

.preset-group-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-right: 4px;
}

.preset-group-list::-webkit-scrollbar {
  width: 4px;
}

.preset-group-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 2px;
}

.preset-group-list::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

.preset-group-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}

.preset-group-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(59, 130, 246, 0.3);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.preset-group-card.added {
  opacity: 0.75;
  background: rgba(255, 255, 255, 0.02);
  border-color: transparent;
}

.preset-card-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.preset-card-icon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: rgba(59, 130, 246, 0.12);
  color: #60a5fa;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s;
}

.preset-group-card:hover .preset-card-icon {
  background: rgba(59, 130, 246, 0.22);
  transform: scale(1.05);
}

.preset-card-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.preset-card-title-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.preset-card-title {
  font-size: 0.88rem;
  font-weight: 500;
  color: #fff;
  white-space: nowrap;
}

.preset-tag {
  font-size: 0.65rem;
  padding: 1px 5px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.6);
  white-space: nowrap;
}

.preset-card-desc {
  font-size: 0.73rem;
  color: rgba(255, 255, 255, 0.4);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.preset-card-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: 8px;
}

.preset-add-btn {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  background: rgba(59, 130, 246, 0.15);
  border: 1px solid rgba(59, 130, 246, 0.35);
  color: #60a5fa;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 0.78rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.preset-group-card:hover .preset-add-btn {
  background: #3b82f6;
  border-color: #3b82f6;
  color: #fff;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.4);
}

.preset-status-badge.added {
  font-size: 0.74rem;
  color: rgba(255, 255, 255, 0.45);
  background: rgba(255, 255, 255, 0.06);
  padding: 3px 8px;
  border-radius: 6px;
}

/* Custom Group Tab */
.custom-group-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.custom-group-container .form-label {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 6px;
  flex-shrink: 0;
}

.icon-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 6px;
  margin-bottom: 12px;
  flex-shrink: 0;
}

.icon-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  aspect-ratio: 1;
  border-radius: 8px;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid transparent;
  transition: all 0.2s ease;
}

.icon-cell:hover {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.95);
  transform: scale(1.05);
}

.icon-cell.selected {
  color: #fff;
  background: rgba(59, 130, 246, 0.25);
  border-color: rgba(59, 130, 246, 0.6);
  box-shadow: 0 0 10px rgba(59, 130, 246, 0.3);
}

.icon-cell {
  position: relative;
}

.icon-cell[data-title]:hover::after {
  content: attr(data-title);
  position: absolute;
  bottom: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 11px;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  animation: tooltipFadeIn 0.2s forwards;
  animation-delay: 0.1s;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.85);
  color: #fff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  border: 1px solid rgba(255,255,255,0.1);
}

.add-group-form {
  margin-bottom: 0;
  flex-shrink: 0;
}

.group-name-input {
  width: 100%;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 9px 12px;
  color: #fff;
  font-size: 0.88rem;
  outline: none;
  box-sizing: border-box;
  transition: all 0.2s;
}

.group-name-input:focus {
  border-color: #3b82f6;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
}

.group-name-input::placeholder {
  color: rgba(255, 255, 255, 0.3);
}

.add-group-actions {
  display: flex;
  gap: 10px;
  margin-top: auto;
  padding-top: 14px;
  flex-shrink: 0;
}

.btn-primary, .btn-secondary {
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 0.88rem;
  font-weight: 500;
  cursor: pointer;
  border: none;
  flex: 1;
  text-align: center;
  transition: all 0.2s;
}

.btn-primary {
  background: #3b82f6;
  color: #fff;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.btn-primary:hover {
  background: #2563eb;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4);
  transform: translateY(-1px);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
}

.weather-container.horizontal .temp {
  font-size: 2.5rem;
}

.weather-container.horizontal .desc,
.weather-container.horizontal .location {
  font-size: 1.2rem;
  margin: 0;
}

/* Custom Context Menu */
.custom-context-menu {
  position: absolute;
  background: #2a2a2d;
  border-radius: 8px;
  padding: 6px;
  min-width: 120px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
  z-index: 1000;
  display: flex;
  flex-direction: column;
}

.context-menu-item {
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  color: #fff;
  font-size: 0.9rem;
  transition: background 0.2s;
  display: flex;
  align-items: center;
}

.context-menu-item:hover {
  background: rgba(255, 255, 255, 0.1);
}

.context-menu-item.delete {
  color: #ef4444;
}

.context-menu-item.delete:hover {
  background: rgba(239, 68, 68, 0.1);
}

/* Settings Modal Overlay & Layout */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(8px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.settings-overlay {
  align-items: flex-end;
}

.settings-modal-wrapper {
  position: relative;
}

.settings-modal {
  width: 1240px;
  height: 960px;
  max-height: 95vh;
  background: transparent;
  border-radius: 20px 20px 0 0;
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-bottom: none;
  display: flex;
  overflow: hidden;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6);
  color: #fff;
  position: relative;
  z-index: 2;
  animation: modalBorderBreathe 2.5s ease-in-out infinite alternate;
  transition: all 0.3s ease;
}

.settings-modal::before {
  content: "";
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: -1;
  background-image: 
    radial-gradient(circle at 10% 10%, rgba(99, 102, 241, 0.45) 0%, transparent 60%),
    radial-gradient(circle at 90% 10%, rgba(236, 72, 153, 0.45) 0%, transparent 60%),
    radial-gradient(circle at 90% 90%, rgba(234, 179, 8, 0.35) 0%, transparent 60%),
    radial-gradient(circle at 10% 90%, rgba(20, 184, 166, 0.45) 0%, transparent 60%),
    linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  background-size: cover;
  background-attachment: fixed;
  border-radius: inherit;
  opacity: 0.85;
}

.settings-modal.maximized {
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
  border-radius: 0;
  border: none;
}

@keyframes modalBorderBreathe {
  0% {
    border-color: rgba(59, 130, 246, 0.1);
    box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6), 0 0 10px rgba(59, 130, 246, 0.1), inset 0 0 10px rgba(59, 130, 246, 0.05);
  }
  100% {
    border-color: rgba(59, 130, 246, 0.6);
    box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6), 0 0 25px rgba(59, 130, 246, 0.3), inset 0 0 15px rgba(59, 130, 246, 0.1);
  }
}



/* Sidebar */
.settings-sidebar {
  width: 280px;
  background: rgba(0, 0, 0, 0.25);
  border-right: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.settings-sidebar-header {
  padding: 30px 20px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.settings-user-avatar {
  width: 44px;
  height: 44px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  padding: 8px;
  box-sizing: border-box;
}

.search-action-btn {
  width: 32px;
  height: 32px;
  transition: all 0.2s;
}
.search-action-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

.settings-login-btn {
  background: #3b82f6;
  color: #fff;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.settings-login-btn:hover {
  background: #2563eb;
}

.settings-nav {
  display: flex;
  flex-direction: column;
  padding: 0 12px;
  gap: 4px;
  overflow-y: auto;
}

.settings-nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 18px;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  font-size: 1.05rem;
  transition: all 0.2s;
  position: relative;
}

.settings-nav-item:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
}

.settings-nav-item.active {
  background: rgba(59, 130, 246, 0.15);
  color: #3b82f6;
  font-weight: 500;
}

.settings-nav-item.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 16px;
  width: 3px;
  background: #3b82f6;
  border-radius: 0 4px 4px 0;
}

/* Content Area */
.settings-content-wrapper {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  background: rgba(20, 20, 24, 0.4);
}

.settings-controls {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 10;
}

.settings-maximize,
.settings-close {
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: 6px;
  transition: all 0.2s;
}

.settings-maximize:hover,
.settings-close:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.15);
}

.settings-panel-content {
  padding: 30px 40px;
  overflow-y: auto;
  height: 100%;
}

/* Custom Scrollbar for Settings Panel Content */
.settings-panel-content::-webkit-scrollbar {
  width: 8px;
}
.settings-panel-content::-webkit-scrollbar-track {
  background: transparent;
  margin-top: 30px;
  margin-bottom: 30px;
}
.settings-panel-content::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 4px;
}
.settings-panel-content::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

.settings-panel-title {
  font-size: 1.8rem;
  font-weight: 500;
  margin: 0 0 16px 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.settings-panel-subtitle {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.4);
  font-weight: 400;
}

/* Cards & Controls */
.settings-card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 12px;
}

.settings-card-header {
  font-size: 1.1rem;
  font-weight: 500;
  margin-bottom: 16px;
  color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.settings-row-control {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  font-size: 1.05rem;
  color: rgba(255, 255, 255, 0.7);
}

.settings-row-control:last-child {
  margin-bottom: 0;
}

/* Custom Controls */
.settings-switch {
  width: 44px;
  height: 24px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  transition: background 0.3s;
}

.settings-switch.active {
  background: #3b82f6;
}

.settings-switch-thumb {
  width: 20px;
  height: 20px;
  background: #fff;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.settings-switch.active .settings-switch-thumb {
  transform: translateX(20px);
}

.settings-range-container {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 240px;
}

.settings-range {
  flex: 1;
  -webkit-appearance: none;
  height: 4px;
  border-radius: 2px;
  outline: none;
}

.settings-range::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  box-shadow: 0 0 0 2px #3b82f6;
}

.settings-range-val {
  min-width: 65px;
  text-align: right;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
  white-space: nowrap;
}

/* Visual Option Cards */
.settings-visual-options {
  display: flex;
  gap: 20px;
  margin-bottom: 16px;
}

.settings-visual-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}

.settings-visual-preview {
  width: 100%;
  height: 100px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  position: relative;
  overflow: hidden;
}

.settings-visual-card.active .settings-visual-preview {
  border-color: #3b82f6;
  background: rgba(59, 130, 246, 0.05);
  box-shadow: 0 0 0 1px #3b82f6;
}

.settings-visual-card span {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.6);
  transition: color 0.2s;
}

.settings-visual-card.active span {
  color: #fff;
}

.preview-icon-box {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.light-preview { background: #f3f4f6; color: rgba(0, 0, 0, 0.5); }
.dark-preview { background: #1f2937; color: #fff; }
.preview-clock { font-size: 1.2rem; font-weight: 500; position: absolute; top: 15px; }
.preview-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 4px; margin-top: 20px;}
.preview-grid div { width: 12px; height: 12px; background: rgba(128,128,128,0.3); border-radius: 2px;}

.sidebar-preview { justify-content: flex-start; }
.sidebar-preview.right { justify-content: flex-end; }
.sidebar-col { width: 30%; height: 100%; background: rgba(128,128,128,0.2); display: flex; flex-direction: column; gap: 4px; padding: 8px; box-sizing: border-box; }
.sidebar-col div { width: 100%; height: 12px; background: rgba(128,128,128,0.3); border-radius: 2px;}

.layout-preview .preview-line { width: 60px; height: 4px; background: rgba(128,128,128,0.3); border-radius: 2px; margin-top: 30px;}
.layout-badge { 
  background: rgba(255,255,255,0.1); 
  padding: 6px 18px; 
  border-radius: 12px; 
  font-size: 0.9rem;
  color: rgba(255,255,255,0.7);
}
.settings-visual-card.active .layout-badge {
  background: #3b82f6;
  color: #fff;
}

/* Color Picker */
.settings-color-picker {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.color-dot {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid transparent;
  transition: transform 0.2s;
  position: relative;
  flex-shrink: 0;
}

.color-dot:hover {
  transform: scale(1.1);
}

.color-dot.active {
  border-color: #fff;
  transform: scale(1.1);
}
.color-dot.active::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 10px;
  text-shadow: 0 1px 2px rgba(0,0,0,0.5);
}

.color-dot.light-bg.active {
  border-color: rgba(0,0,0,0.2);
}
.color-dot.light-bg.active::after {
  color: #333;
  text-shadow: none;
}

/* Unit Toggle */
.settings-unit-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.8rem;
  color: rgba(255,255,255,0.4);
}
.settings-unit-toggle .active-text { color: #3b82f6; }

/* Wallpaper specific */
.wallpaper-categories {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.wallpaper-category {
  padding: 4px 16px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: var(--text-secondary, #999);
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
}

.wallpaper-category:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.wallpaper-category.active {
  background: #3b82f6;
  color: #fff;
  border-color: #3b82f6;
}

.wallpaper-grid-wrapper {
  max-height: 420px;
  min-height: 420px;
  overflow-y: auto;
  margin-right: -10px;
  padding-right: 10px;
}
.wallpaper-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

/* Custom scrollbar for wallpaper grid */
.wallpaper-grid-wrapper::-webkit-scrollbar {
  width: 8px; /* Slightly wider to accommodate invisible border */
}
.wallpaper-grid-wrapper::-webkit-scrollbar-track {
  background: transparent;
}
.wallpaper-grid-wrapper::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 4px;
      border: 2px solid transparent;
  border-top-width: 16px;
  border-bottom-width: 16px;
  background-clip: padding-box;
}
.wallpaper-grid-wrapper:hover::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
}
.wallpaper-grid-wrapper:hover::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.4);
}

.theme-light .wallpaper-grid-wrapper-wrapper::-webkit-scrollbar-thumb {
  background-color: transparent;
}
.theme-light .wallpaper-grid-wrapper-wrapper:hover::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
}
.theme-light .wallpaper-grid-wrapper-wrapper:hover::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.4);
}

.wallpaper-thumbnail-container {
  padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
  height: 0;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
}

.wallpaper-thumbnail {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.wallpaper-thumbnail-container:hover .wallpaper-thumbnail {
  transform: scale(1.05);
}

.wallpaper-thumbnail-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.2s;
}

.wallpaper-thumbnail-container:hover .wallpaper-thumbnail-overlay {
  opacity: 1;
}

.wallpaper-overlay-icons {
  display: flex;
  gap: 4px;
  position: absolute;
  bottom: 6px;
  right: 6px;
}

.wallpaper-overlay-icon {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
}

.wallpaper-overlay-icon[data-title]:hover::after {
  content: attr(data-title);
  position: absolute;
  bottom: calc(100% + 6px);
  top: auto;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.85);
  color: #fff;
  padding: 3px 6px;
  border-radius: 4px;
  font-size: 10px;
  white-space: nowrap;
  pointer-events: none;
  z-index: 10;
}

.theme-light .wallpaper-overlay-icon[data-title]:hover::after {
  background: rgba(255, 255, 255, 0.95);
  color: #333;
  border: 1px solid rgba(0,0,0,0.1);
}

.wallpaper-overlay-icon:hover {
  background: #3b82f6;
  border-color: #3b82f6;
  transform: scale(1.1);
}

/* Other Controls */
.settings-select {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: var(--text-color, rgba(255, 255, 255, 0.9));
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  cursor: pointer;
  transition: all 0.2s;
}

.settings-select:hover {
  background: rgba(255, 255, 255, 0.1);
}

.settings-select option { 
  background: #1f1f23; 
  color: rgba(255, 255, 255, 0.9); 
  font-size: 14px;
}

.settings-backup-primary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #3b82f6;
  color: #fff !important;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}
.settings-backup-primary:hover {
  background: #2563eb;
}

.settings-backup-secondary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: var(--text-color, rgba(255, 255, 255, 0.9));
  padding: 7px 19px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}
.settings-backup-secondary:hover {
  background: rgba(255, 255, 255, 0.05);
}

.settings-danger-btn {
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.6);
  padding: 12px;
  border-radius: 8px;
  text-align: center;
  font-size: 1.05rem;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 10px;
}

.settings-danger-btn:hover {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.settings-separator {
  height: 1px;
  background: rgba(255, 255, 255, 0.05);
  margin: 20px 0;
}

.action-row {
  padding: 16px 20px;
  cursor: pointer;
  transition: background 0.2s;
  font-size: 1.05rem;
}

.action-row:hover {
  background: rgba(255, 255, 255, 0.03);
}

.primary-text {
  color: #3b82f6;
}

.action-card { padding: 0; overflow: hidden; }

.feedback-textarea {
  width: 100%;
  height: 150px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 16px;
  color: #fff;
  resize: none;
  font-family: inherit;
  box-sizing: border-box;
}

.feedback-textarea:focus { outline: 1px solid #3b82f6; }

.submit-btn {
  background: #3b82f6;
  color: #fff;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1.05rem;
}

.danger-btn {
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
  border: 1px solid rgba(239, 68, 68, 0.3);
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1.05rem;
}

/* Delete Confirm Modal */
.confirm-modal {
  background: #1f1f1f;
  border-radius: 12px;
  width: 400px;
  padding: 24px;
  position: relative;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  color: #fff;
  font-family: inherit;
}
.confirm-modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.45);
}
.confirm-modal-close:hover {
  color: #fff;
}
.confirm-modal-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 20px;
}
.confirm-modal-body {
  text-align: center;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 24px;
}
.confirm-modal-footer {
  display: flex;
  justify-content: center;
  gap: 16px;
}
.confirm-btn-cancel {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  padding: 6px 24px;
  border-radius: 16px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}
.confirm-btn-cancel:hover {
  border-color: rgba(255, 255, 255, 0.4);
}
.confirm-btn-ok {
  background: #1890ff;
  border: none;
  color: #fff;
  padding: 6px 24px;
  border-radius: 16px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}
.confirm-btn-ok:hover {
  background: #40a9ff;
}

#wechat-qrcode-container {
  width: 240px !important;
  height: 240px !important;
  min-height: 240px !important;
  background: #fff;
  border: none;
  margin: 0 auto;
  margin-bottom: 0.5rem;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

#wechat-qrcode-container iframe {
  width: 300px !important;
  height: 400px !important;
  display: block;
  position: absolute;
  top: 25px;
  left: 0;
  transform: scale(0.8);
  transform-origin: top left;
}

/* Responsive Adaptation for smaller screens (e.g. 11-14 inch laptops) */
@media screen and (max-height: 850px), screen and (max-width: 1400px) {
  .top-row {
    margin: 5vh auto 0.5rem auto !important;
    zoom: var(--app-zoom, 0.85);
  }
  
  .main-content {
    padding: 0.6rem 0.6rem 100px 0.6rem !important;
  }

  .pages-viewport {
    zoom: var(--app-zoom, 0.85);
    width: 100%;
  }

  .bottom-menu {
    transform-origin: bottom center;
    bottom: 20px !important;
  }
  
  .bottom-menu.dock-menu {
    transform: translateX(-50%) !important;
    zoom: var(--app-zoom, 0.85);
  }

  .bottom-right-actions {
    bottom: 8px !important;
  }

  /* Target the buttons inside to avoid breaking the container's transform animations */
  .bottom-right-actions .action-btn {
    zoom: var(--app-zoom, 0.85);
  }

  .sidebar-menu-bar {
    transform: translateY(-50%) !important;
    zoom: var(--app-zoom, 0.85);
  }
  
  .sidebar-menu-bar.right {
    transform-origin: right center;
  }
  
  /* Target the inner modal to avoid overriding framer-motion inline transforms */
  .settings-modal, .modal-content {
    zoom: var(--modal-zoom, 0.78);
    max-height: none !important;
    max-width: none !important;
  }
}

/* Extra small screens */
@media screen and (max-height: 700px), screen and (max-width: 1024px) {
  .top-row {
    margin: 4vh auto 0.3rem auto !important;
    zoom: var(--app-zoom, 0.75);
  }
  
  .pages-viewport {
    zoom: var(--app-zoom, 0.75);
  }

  .bottom-menu.dock-menu {
    transform: translateX(-50%) !important;
    zoom: var(--app-zoom, 0.75);
    bottom: 20px !important;
  }
  
  .bottom-right-actions {
    bottom: 0px !important;
  }
  
  .bottom-right-actions .action-btn {
    zoom: var(--app-zoom, 0.75);
  }

  .sidebar-menu-bar {
    transform: translateY(-50%) !important;
    zoom: var(--app-zoom, 0.75);
  }
  
  .settings-modal, .modal-content {
    zoom: var(--modal-zoom, 0.65);
    max-height: none !important;
    max-width: none !important;
  }
}

/* Custom Scrollbar class */
.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 4px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

.search-history-toggle {
  opacity: 0;
  transition: opacity 0.2s, background-color 0.2s;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
}

.search-history-toggle:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.search-box-wrapper:hover .search-history-toggle {
  opacity: 1;
}

.search-dropdown-panel {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: rgba(30, 30, 30, 0.95);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 12px;
  margin-top: 8px;
  padding: 16px;
  z-index: 100;
  color: #fff;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
  text-align: left;
}

.search-dropdown-panel .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 13px;
  color: rgba(255,255,255,0.6);
}

.search-dropdown-panel .clear-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: color 0.2s;
}

.search-dropdown-panel .clear-btn:hover {
  color: rgba(255,255,255,0.9);
}

.search-dropdown-panel .tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
}

.search-dropdown-panel .tag {
  background: rgba(255,255,255,0.08);
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.search-dropdown-panel .tag:hover {
  background: rgba(255,255,255,0.15);
}

.search-dropdown-panel .hot-searches {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.search-dropdown-panel .hot-search-item {
  font-size: 13px;
  color: rgba(255,255,255,0.85);
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  transition: color 0.2s;
}

.search-dropdown-panel .hot-search-item:hover {
  color: #fff;
}

.search-dropdown-panel .ranking-col-header {
  font-size: 12px;
  color: rgba(255,255,255,0.5);
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.search-dropdown-panel .ranking-col-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.search-dropdown-panel .hot-search-number {
  color: rgba(255,255,255,0.4);
  margin-right: 6px;
  font-weight: normal;
  min-width: 14px;
  font-size: 14px;
  font-style: italic;
}

.search-dropdown-panel .hot-search-number.top-3 {
  color: #ff4d4f;
  font-weight: bold;
}

.search-dropdown-panel .hot-search-text {
  overflow: hidden;
  text-overflow: ellipsis;
}

.search-history-chevron {
  opacity: 0;
  transition: opacity 0.2s;
}

.search-box-wrapper:hover .search-history-chevron {
  opacity: 1;
}

/* Custom Scrollbars for Weather Modal */
.weather-modal-scroll::-webkit-scrollbar,
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.weather-modal-scroll::-webkit-scrollbar-track,
.custom-scrollbar::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
}

.weather-modal-scroll::-webkit-scrollbar-thumb,
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
}

.weather-modal-scroll::-webkit-scrollbar-thumb:hover,
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.4);
}



.recommend-dropdown {
  background: rgba(20, 20, 20, 0.8);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(255,255,255,0.1);
}

.recommend-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  padding: 16px;
}

.recommend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px;
  border-radius: 12px;
  transition: background 0.2s;
}

.recommend-item:hover {
  background: rgba(255,255,255,0.1);
}

.recommend-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255,255,255,0.05);
  flex-shrink: 0;
  color: rgba(255,255,255,0.8);
}

.recommend-text {
  color: rgba(255,255,255,0.9);
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Light Theme - Search Dropdowns */
.theme-light .search-dropdown-panel {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1) !important;
}

.theme-light .search-engine-dropdown {
  background: rgba(255, 255, 255, 0.92) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1) !important;
}

.theme-light .recommend-dropdown {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1) !important;
}

.theme-light .settings-modal {
  background: transparent !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1) !important;
  color: var(--text-color) !important;
}

.theme-light .modal-content,
.theme-light .add-group-modal,
.theme-light .confirm-modal {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.15) !important;
  color: #1f1f1f !important;
}

.theme-light .confirm-modal-header {
  color: #1f1f1f !important;
}

.theme-light .confirm-modal-body {
  color: rgba(0, 0, 0, 0.85) !important;
}

.theme-light .confirm-modal-title-text {
  color: #1a1a1a !important;
}

.theme-light .confirm-modal-subtitle {
  color: rgba(0, 0, 0, 0.65) !important;
}

.theme-light .confirm-modal-close {
  color: rgba(0, 0, 0, 0.45) !important;
}

.theme-light .confirm-modal-close:hover {
  color: rgba(0, 0, 0, 0.85) !important;
}

.theme-light .confirm-btn-cancel {
  background: rgba(0, 0, 0, 0.05) !important;
  border: 1px solid rgba(0, 0, 0, 0.15) !important;
  color: rgba(0, 0, 0, 0.85) !important;
}

.theme-light .confirm-btn-cancel:hover {
  background: rgba(0, 0, 0, 0.1) !important;
  border-color: rgba(0, 0, 0, 0.25) !important;
  color: #000 !important;
}

.theme-light .settings-modal::before {
  background-image: 
    radial-gradient(circle at 10% 10%, rgba(99, 102, 241, 0.45) 0%, transparent 60%),
    radial-gradient(circle at 90% 10%, rgba(244, 114, 182, 0.25) 0%, transparent 60%),
    radial-gradient(circle at 90% 90%, rgba(234, 179, 8, 0.35) 0%, transparent 60%),
    radial-gradient(circle at 10% 90%, rgba(20, 184, 166, 0.45) 0%, transparent 60%),
    linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 100%) !important;
  filter: none !important;
  opacity: 1 !important;
}

.theme-light .settings-content-wrapper {
  background: transparent !important;
}

.theme-light .settings-sidebar {
  background: rgba(255, 255, 255, 0.4) !important;
  border-right: 1px solid rgba(0, 0, 0, 0.1) !important;
}

.theme-light .settings-nav-item {
  color: var(--text-secondary) !important;
}

.theme-light .settings-nav-item:hover {
  background: var(--bg-hover) !important;
  color: var(--text-color) !important;
}

.theme-light .settings-card-header {
  color: var(--text-color) !important;
}

.theme-light .settings-card {
  background: rgba(0, 0, 0, 0.04) !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
}

.theme-light .settings-row-control,
.theme-light .settings-visual-card span {
  color: var(--text-secondary) !important;
}

.theme-light .settings-panel-subtitle {
  color: var(--text-muted) !important;
}

.theme-light .settings-visual-preview {
  background: rgba(0, 0, 0, 0.05) !important;
  border-color: rgba(0, 0, 0, 0.15) !important;
}

.theme-light .preview-icon-box {
  background: rgba(0, 0, 0, 0.1) !important;
}

.theme-light .settings-range-container {
  --track-bg: rgba(0, 0, 0, 0.15);
}

.theme-light .settings-switch {
  background: rgba(0, 0, 0, 0.15) !important;
}

.theme-light .settings-switch.active {
  background: #3b82f6 !important;
}
.theme-light .settings-range-val {
  color: var(--text-secondary) !important;
}

.theme-light .layout-badge {
  background: rgba(0, 0, 0, 0.1) !important;
  color: var(--text-secondary) !important;
}

.theme-light .settings-visual-card.active .layout-badge {
  background: #3b82f6 !important;
  color: #fff !important;
}

.theme-light .settings-danger-btn {
  color: var(--text-secondary) !important;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  background: rgba(0, 0, 0, 0.06) !important;
}

.theme-light .settings-danger-btn:hover {
  background: rgba(239, 68, 68, 0.1) !important;
  color: #ef4444 !important;
  border-color: rgba(239, 68, 68, 0.3) !important;
}

.theme-light .settings-backup-secondary {
  border-color: rgba(0, 0, 0, 0.2) !important;
  color: var(--text-color) !important;
}
.theme-light .settings-backup-secondary:hover {
  background: rgba(0, 0, 0, 0.05) !important;
}

.theme-light .wallpaper-category {
  background: rgba(0, 0, 0, 0.05) !important;
  border-color: rgba(0, 0, 0, 0.1) !important;
  color: var(--text-secondary) !important;
}

.theme-light .wallpaper-category:hover {
  background: rgba(0, 0, 0, 0.1) !important;
  color: var(--text-color) !important;
}

.theme-light .wallpaper-category.active {
  background: #3b82f6 !important;
  color: #fff !important;
  border-color: #3b82f6 !important;
}

.theme-light .wallpaper-thumbnail-container {
  border-color: rgba(0, 0, 0, 0.1) !important;
}

.theme-light .settings-unit-toggle {
  color: var(--text-muted) !important;
}

.theme-light .settings-select {
  background: rgba(0, 0, 0, 0.05) !important;
  border-color: rgba(0, 0, 0, 0.1) !important;
  color: var(--text-color) !important;
}

.theme-light .settings-select:hover {
  background: rgba(0, 0, 0, 0.08) !important;
}

.theme-light .settings-select option {
  background: #ffffff !important;
  color: rgba(0, 0, 0, 0.9) !important;
}

.theme-light .settings-close {
  color: var(--text-secondary) !important;
}

.theme-light .settings-close:hover {
  color: var(--text-color) !important;
  background: var(--bg-hover) !important;
}

.theme-light .modal-overlay {
  background: rgba(0, 0, 0, 0.1) !important;
}



.theme-light .hover-widget:hover {
  background: rgba(255, 255, 255, 0.3) !important;
}

/* Add Group Modal Light Theme Overrides */
.theme-light .add-group-close-btn {
  color: var(--text-secondary);
}
.theme-light .add-group-close-btn:hover {
  color: var(--text-color);
  background: var(--bg-hover);
}
.theme-light .add-group-header {
  color: var(--text-color);
}
.theme-light .add-group-tabs {
  background: var(--bg-hover);
}
.theme-light .add-group-tab {
  color: var(--text-secondary);
}
.theme-light .add-group-tab:hover {
  color: var(--text-color);
  background: var(--bg-hover-light);
}
.theme-light .add-group-tab.active {
  color: #ffffff;
}
.theme-light .preset-group-subtitle {
  color: var(--text-muted);
}
.theme-light .preset-group-card {
  background: var(--bg-hover-light);
  border: 1px solid var(--border-color);
}
.theme-light .preset-group-card:hover {
  background: var(--bg-hover);
  border-color: rgba(59, 130, 246, 0.4);
}
.theme-light .preset-group-card.added {
  background: rgba(0, 0, 0, 0.02);
}
.theme-light .preset-card-title {
  color: var(--text-secondary);
}
.theme-light .preset-card-desc {
  color: var(--text-muted);
}
.theme-light .preset-add-btn {
  color: #3b82f6;
}
.theme-light .preset-group-list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
}
.theme-light .preset-group-list::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

/* Custom Group Tab Light Theme Overrides */
.theme-light .icon-cell {
  color: var(--text-secondary);
  background: var(--bg-hover-light);
}
.theme-light .icon-cell:hover {
  background: var(--bg-hover);
  color: var(--text-color);
}
.theme-light .icon-cell.selected {
  color: #fff;
  background: #3b82f6;
  border-color: rgba(59, 130, 246, 0.6);
}
.theme-light .icon-cell[data-title]:hover::after {
  background: rgba(255, 255, 255, 0.95);
  color: #333;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}
.theme-light .custom-group-container .form-label {
  color: var(--text-secondary);
}
.theme-light .group-name-input {
  background: rgba(0, 0, 0, 0.04);
  border-color: var(--border-color);
  color: var(--text-color);
}
.theme-light .group-name-input:focus {
  background: rgba(0, 0, 0, 0.08);
  border-color: #3b82f6;
}
.theme-light .group-name-input::placeholder {
  color: var(--text-muted);
}
.theme-light .btn-secondary {
  background: var(--bg-hover-light);
  color: var(--text-secondary);
  border-color: var(--border-color);
}
.theme-light .btn-secondary:hover {
  background: var(--bg-hover);
  color: var(--text-color);
}

.hover-scrollbar::-webkit-scrollbar-thumb {
  background: transparent !important;
  transition: background-color 0.3s;
}
.hover-scrollbar.is-scrolling::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2) !important;
}
.theme-light .hover-scrollbar.is-scrolling::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2) !important;
}
.hover-scrollbar::-webkit-scrollbar-track {
  background: transparent !important;
}

.theme-light .search-box:focus {
  background: rgba(255, 255, 255, 0.98) !important;
  border-color: rgba(0, 0, 0, 0.1) !important;
}

/* Light Theme Text Overrides for Dropdowns */
.theme-light .search-dropdown-panel .section-header { color: rgba(0, 0, 0, 0.5) !important; }
.theme-light .search-dropdown-panel .clear-btn { color: rgba(0, 0, 0, 0.5) !important; }
.theme-light .search-dropdown-panel .clear-btn:hover { color: rgba(0, 0, 0, 0.9) !important; }
.theme-light .search-dropdown-panel .tag { background: rgba(0, 0, 0, 0.05) !important; color: #333 !important; }
.theme-light .search-dropdown-panel .tag:hover { background: rgba(0, 0, 0, 0.1) !important; }
.theme-light .search-dropdown-panel .hot-search-item { color: rgba(0, 0, 0, 0.7) !important; }
.theme-light .search-dropdown-panel .hot-search-item:hover { color: #000 !important; }
.theme-light .search-dropdown-panel .ranking-col-header { color: rgba(0, 0, 0, 0.5) !important; }
.theme-light .search-dropdown-panel .hot-search-number { color: rgba(0, 0, 0, 0.4) !important; }
.theme-light .search-dropdown-panel .hot-search-number.top-3 { color: #ff4d4f !important; }

.theme-light .search-engine-item { color: rgba(0, 0, 0, 0.7) !important; }
.theme-light .search-engine-item:hover { background: rgba(0, 0, 0, 0.05) !important; }

.theme-light .recommend-item { color: rgba(0, 0, 0, 0.7) !important; }
.theme-light .recommend-item:hover { background: rgba(0, 0, 0, 0.05) !important; }
.theme-light .recommend-icon-wrapper { color: rgba(0, 0, 0, 0.6) !important; background: rgba(0,0,0,0.05) !important; }
.theme-light .recommend-text { color: rgba(0, 0, 0, 0.85) !important; }

/* Light Theme - Main Grid Shortcut Icons */
.theme-light .shortcut-icon {
  background: transparent !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  border: none !important;
  box-shadow: none !important;
}

.theme-light .shortcut-icon img {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain;
}

/* Light Theme - Colorful Widgets */
.theme-light .widget-body {
  background: linear-gradient(135deg, #e0c3fc 0%, #8ec5fc 100%) !important;
  border-color: transparent !important;
  box-shadow: 0 8px 24px rgba(0,0,0,0.1) !important;
}
.theme-light .widget-weather {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%) !important;
  color: #ffffff !important;
}
.theme-light .widget-hotsearch {
  background: linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%) !important;
}
.theme-light .widget-translate {
  background: linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%) !important;
}
.theme-light .widget-express {
  background: linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%) !important;
}


.theme-light .add-new-item .shortcut-icon {
  border: 2px dashed rgba(0,0,0,0.2) !important;
  background: rgba(0,0,0,0.05) !important;
  color: rgba(0,0,0,0.5) !important;
}

/* Light Theme - Background */
.theme-light .background-layer {
  background-image: var(--bg-image, none) !important;
  filter: brightness(1) contrast(1.05) var(--bg-blur, blur(0px)) !important;
}

/* Light Theme - Search Bar and Icons */
.rolling-hot-search {
  color: rgba(255, 255, 255, 0.5);
}
.theme-light .rolling-hot-search {
  color: rgba(0, 0, 0, 0.5) !important;
}
.theme-light .search-box::placeholder {
  color: rgba(0, 0, 0, 0.5) !important;
}
.theme-light .search-clear-btn, 
.theme-light .search-history-toggle, 
.theme-light .search-action-btn {
  color: rgba(0,0,0,0.6) !important;
}

/* Custom Settings Select */
.custom-settings-select {
  position: relative;
  display: inline-block;
  min-width: 140px;
}
.custom-settings-select-trigger {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--button-bg, rgba(255, 255, 255, 0.05));
  color: var(--text-color, rgba(255, 255, 255, 0.9));
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  backdrop-filter: blur(10px);
}
.custom-settings-select-trigger:hover {
  background: rgba(255, 255, 255, 0.1);
}
.custom-settings-select-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  background: rgba(30, 30, 35, 0.85);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  overflow: hidden;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}
.custom-settings-select-option {
  padding: 8px 12px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  transition: all 0.2s;
}
.custom-settings-select-option:hover {
  background: rgba(255, 255, 255, 0.1);
}
.custom-settings-select-option.selected {
  color: #3b82f6;
  background: rgba(59, 130, 246, 0.1);
}

.theme-light .custom-settings-select-trigger {
  background: rgba(0, 0, 0, 0.05);
  color: var(--text-color);
}
.theme-light .custom-settings-select-trigger:hover {
  background: rgba(0, 0, 0, 0.08);
}
.theme-light .custom-settings-select-dropdown {
  background: rgba(240, 240, 240, 0.95);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);
}
.theme-light .custom-settings-select-option {
  color: rgba(0, 0, 0, 0.9);
}
.theme-light .custom-settings-select-option:hover {
  background: rgba(0, 0, 0, 0.05);
}
.theme-light .custom-settings-select-option.selected {
  color: #2563eb;
  background: rgba(59, 130, 246, 0.1);
}

.wallpaper-overlay-icon:last-child[data-title]:hover::after {
  left: auto;
  right: -4px;
  transform: none;
}
